import { LayoutHeader } from "@/Header";
import { createFileRoute } from "@tanstack/react-router";
import {
  useMyInquiries,
  type InquiryStatus,
  type MyInquiry,
} from "~/services/customer/inquiry";

export const Route = createFileRoute("/customer/layout/inquiry-history")({
  component: RouteComponent,
});

const STATUS_META: Record<InquiryStatus, { label: string; className: string }> =
  {
    RECEIVED: { label: "접수", className: "bg-[#FFF3E0] text-[#E8890B]" },
    IN_PROGRESS: { label: "처리중", className: "bg-gray-100 text-gray-600" },
    DONE: { label: "완료", className: "bg-green-50 text-green-600" },
    REJECTED: { label: "반려", className: "bg-gray-100 text-gray-400" },
  };

const formatDate = (s?: string | null) => (s ? s.slice(0, 10) : "");

function InquiryCard({ item }: { item: MyInquiry }) {
  const meta = STATUS_META[item.status] ?? STATUS_META.RECEIVED;
  return (
    <div className="p-4 mb-3 bg-white rounded-xl shadow-sm">
      <div className="flex gap-2 items-center mb-2">
        <span
          className={`px-2 py-0.5 text-xs font-semibold rounded-full ${meta.className}`}
        >
          {meta.label}
        </span>
        <span className="text-xs text-gray-500">
          {item.companyName || "매장 미지정"}
          {item.subType ? ` · ${item.subType}` : ""}
        </span>
      </div>

      <p className="text-sm leading-relaxed text-gray-800 whitespace-pre-wrap">
        {item.content}
      </p>
      <p className="mt-2 text-xs text-gray-400">
        {formatDate(item.createdAt)} 접수
      </p>

      {item.answer ? (
        <div className="p-3 mt-3 rounded-lg bg-yellow/5 border border-yellow/30">
          <div className="flex gap-1 items-center mb-1">
            <span className="text-xs font-semibold text-yellow">
              관리자 답변
            </span>
            {item.answeredAt ? (
              <span className="text-[11px] text-gray-400">
                {formatDate(item.answeredAt)}
              </span>
            ) : null}
          </div>
          <p className="text-sm leading-relaxed text-gray-700 whitespace-pre-wrap">
            {item.answer}
          </p>
        </div>
      ) : null}
    </div>
  );
}

function RouteComponent() {
  const { data: inquiries, isLoading } = useMyInquiries();

  return (
    <>
      <LayoutHeader title={"문의 내역"} hasBackBtn hasFootPrint={false} />
      <div className="flex flex-col flex-1 min-h-0 overflow-y-auto bg-[#F5F5F5]">
        <div className="flex-auto px-4 pt-4 pb-12">
          {isLoading ? (
            <div className="pt-20 text-sm text-center text-gray-400">
              불러오는 중...
            </div>
          ) : !inquiries || inquiries.length === 0 ? (
            <div className="pt-24 text-center">
              <p className="text-sm text-gray-500">아직 문의 내역이 없어요.</p>
              <p className="mt-1 text-xs text-gray-400">
                매장 상세에서 "정보 수정 및 제안"으로 알려주시면 여기에
                표시돼요.
              </p>
            </div>
          ) : (
            inquiries.map((item) => <InquiryCard key={item.id} item={item} />)
          )}
        </div>
      </div>
    </>
  );
}
